import { useState } from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { gaEventTracker } from "@util/helpers";

import WhatsappQRModal from "./components/WhatsappQRModal";

export default function WhatsappQRSkybox(): React.ReactElement {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClick = () => {
    setIsModalOpen(true);
    gaEventTracker("bt on whatsapp", "visible", "/");
  };

  return (
    <>
      <div
        className="relative flex cursor-pointer pr-4"
        data-testid="whatsapp-qr-skybox-component"
        onClick={handleClick}
      >
        <div className="w-[120px] md:w-1/3">
          <div className="flex aspect-square items-center justify-center bg-gray-850">
            <FontAwesomeIcon icon={faWhatsapp} color="#ffffff" size="3x" />
          </div>
        </div>

        <div className="pl-4 md:w-2/3">
          <div className="font-poppins text-4xs font-light uppercase tracking-[1px]">
            NEW
          </div>

          <h2 className="hover:none my-1 font-lct text-base font-bold text-gray-750">
            BT is now on WhatsApp!
          </h2>
        </div>
      </div>

      <WhatsappQRModal {...{ isModalOpen, setIsModalOpen }} />
    </>
  );
}
